import { ArgsType, Field } from '@nestjs/graphql'

@ArgsType()
export class TrackMetricArgs {
  @Field()
  type!: string

  // JSON-encoded payload. Sent as a string so we don't need a custom GraphQL
  // JSON scalar; the server parses it into the metric_tracker.metaData column.
  @Field({ nullable: true })
  metaData?: string
}
